import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class ReloadiframeService {
  subject$ = new Subject<string>();

  constructor() { }
}
